import { useQueryClient } from "@tanstack/react-query";

import API from "../../..";
import { useMutationWrapper } from "../../wrappers";
import { roomDetailsKey, roomListKey } from "../room-query-keys";
import { useApiError } from "@/lib/hooks";

export const useMutationAddDeviceToRoom = (onSuccess: (roomId: string) => void) => {
  const queryCache = useQueryClient();
  const { handleErrors } = useApiError();

  const { mutate, isPending, isSuccess, isError } = useMutationWrapper({
    mutationKey: ["rooms", "add-device-to-room"],
    mutationFn: API.Rooms.addDeviceToRoom,
    onSuccess: async (_, { roomId }) => {
      await Promise.all([
        queryCache.invalidateQueries({ queryKey: roomListKey() }),
        queryCache.invalidateQueries({ queryKey: roomDetailsKey(roomId) }),
      ]);
      onSuccess(roomId);
    },
    onError: handleErrors,
  });

  return { mutate, isPending, isSuccess, isError };
};
